import { useContext } from 'react'
import { ConfirmContext } from '../components/UI/Confirm/ConfirmContext'

export const useConfirm = () => useContext(ConfirmContext)